import { render, staticRenderFns } from "./RentManage.vue?vue&type=template&id=70a0c55c&scoped=true&"
import script from "./RentManage.vue?vue&type=script&lang=js&"
export * from "./RentManage.vue?vue&type=script&lang=js&"
import style0 from "./RentManage.vue?vue&type=style&index=0&id=70a0c55c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0c55c",
  null
  
)

export default component.exports